import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="border-b border-steelLine bg-steel px-4 py-8 sm:py-10" data-id="element-142" data-mp="3kqw54mwtl6h6">
      <div className="mx-auto max-w-5xl" data-id="element-143" data-mp="3fym7sltdl44v">
        <h2 className="text-center text-xl text-white sm:text-3xl" data-id="element-144" data-mp="3fxkxijk6olo7">What Builders Are Saying</h2>
        <ul className="mt-4 grid gap-2.5 md:grid-cols-2 lg:grid-cols-3" data-id="element-145" data-mp="3ayhz3hypldp7">
          {testimonials.map(testimonial => <li key={testimonial.name} className="flex h-full flex-col rounded-md border border-steelLine bg-charcoal p-3.5" data-id="element-146" data-mp="31zwcnbq49ej5">
              <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-147" data-mp="2x11pjxl493t8">
                {[0, 1, 2, 3, 4].map(star => <StarIcon key={star} className="h-3.5 w-3.5 fill-gold text-gold" aria-hidden="true" data-id="element-148" data-mp="v9g9bl2obyo3" />)}
              </div>
              <blockquote className="mt-2 text-sm font-medium leading-snug text-lightGray" data-id="element-149" data-mp="qbeq9058zzcm">
                “{testimonial.quote}”
              </blockquote>
              <footer className="mt-auto pt-2.5" data-id="element-150" data-mp="m51ei1cibncn">
                <p className="font-display text-xs font-extrabold uppercase tracking-wide text-white" data-id="element-151" data-mp="m5t14mo4maqs">
                  — {testimonial.name}
                </p>
                <p className="text-[0.7rem] font-medium text-steelGray" data-id="element-152" data-mp="c6bthzpbdms6">{testimonial.role}</p>
              </footer>
            </li>)}
        </ul>
      </div>
    </section>;
}